<template>
  <div class="pt-xl-4 pt-lg-4 pt-md-4 pt-sm-4 mb-8">
    <v-card class="mx-auto py-xl-4 py-lg-4 py-md-4 py-sm-4" max-width="448" :outlined="$vuetify.breakpoint.smAndUp" :flat="$vuetify.breakpoint.xsOnly">
      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title class="headline mb-1">Recuperar cuenta</v-list-item-title>
          <v-list-item-subtitle>Ingresa el nombre de usuario o el correo</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-form ref="form">
        <v-card-text class="px-xl-8 px-lg-8 px-md-8 px-sm-8 px-5">
          <v-row justify="center" no-gutters>
            <v-col cols="11">
              <v-text-field
                v-model="user.email"
                label="Correo electrónico"
                :rules="[isRequired, isEmail]"
                filled
                dense>
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="px-xl-8 px-lg-8 px-md-8 px-sm-8 px-5 pb-6 mt-n4">
          <v-row justify="center" no-gutters>
            <v-col cols="11" class="mb-2">
              <v-btn class="text-none" block height="48" color="blue darken-1" elevation="0" :loading="loading" dark @click="recover">
                Recuperar cuenta
              </v-btn>
            </v-col>
            <v-col cols="11">
              <v-btn class="text-none" block height="48" color="blue darken-1" elevation="0" outlined dark @click="goToRouteByName('Login')">
                Prefiero iniciar sesión
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import navigationMixin from '@/mixins/navigation'
import { isRequired, isEmail } from '@/shared/validations'
import { getErrorMessage } from '@/shared/errors'

export default {
  mixins: [navigationMixin],
  data () {
    return {
      isRequired,
      isEmail,
      showPassword: false,
      user: {
        email: ''
      }
    }
  },
  computed: {
    ...mapState('shared', ['error', 'loading'])
  },
  methods: {
    ...mapActions('auth', ['recoverAccount']),
    async recover () {
      if (!this.$refs.form.validate()) {
        return
      }

      await this.recoverAccount(this.user)
      if (this.error) {
        this.$emit('notificationPopup', { icon: 'error', color: 'error', message: getErrorMessage('recover_account', this.error) })
        return
      }

      this.$emit('notificationPopup', { icon: 'check_circle', color: 'success', message: 'Se envió un correo de recuperación de contraseña a ' + this.user.email + ', por favor revisa tu correo electrónico' })
    }
  }
}
</script>
<style scoped>
</style>
